import type { U3202CapabilityKey, U3202ModelCapabilities } from './U3202CapabilitiesTypes';

/**
 * Indique si une capability est supportée (capabilities.{key}.supported === true).
 */
export function u3202CapabilitySupported(
  capabilities: U3202ModelCapabilities | null | undefined,
  capabilityKey: U3202CapabilityKey | string,
): boolean {
  if (!capabilities) {
    return false;
  }
  const node = capabilities[capabilityKey as keyof U3202ModelCapabilities];
  if (node && typeof node === 'object' && node !== null && 'supported' in node) {
    return (node as { supported?: boolean }).supported === true;
  }
  return false;
}

/**
 * Retourne les niveaux effort disponibles si déclarés par discover.
 */
export function u3202GetCapabilityLevels(
  capabilities: U3202ModelCapabilities | null | undefined,
  capability: 'effort',
): string[] | undefined {
  if (capability === 'effort') {
    const levels = capabilities?.effort?.levels;
    return Array.isArray(levels) && levels.length > 0 ? levels : undefined;
  }
  return undefined;
}
